import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const employmentStatusMap: Record<EmploymentStatus, MapItem> = {
  full_time: { label: 'Full Time' },
  part_time: { label: 'Part Time' },
  self_employed: { label: 'Self Employed' },
  retired: { label: 'Retired' },
  temporary: { label: 'Temporary' },
  unemployed: { label: 'Unemployed' },
  other: { label: 'Other' },
}

export const employmentStatusSchema = z.enum(
  Object.keys(employmentStatusMap) as [EmploymentStatus, ...EmploymentStatus[]],
)

export type EmploymentStatus =
  | 'full_time'
  | 'part_time'
  | 'self_employed'
  | 'retired'
  | 'temporary'
  | 'unemployed'
  | 'other'
